var _rect, _circle, _circle2, _path, _circle3, _circle4, _circle5, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArmazenamento(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.2251,
    y: 12.15,
    width: 36.45,
    height: 48.6,
    rx: 1.51875,
    stroke: "#A80A01",
    strokeWidth: 3.0375
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.4499,
    cy: 33.4125,
    r: 1.51875,
    stroke: "#A80A01",
    strokeWidth: 1.51875
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36.45,
    cy: 33.4125,
    r: 6.075,
    stroke: "#A80A01",
    strokeWidth: 1.51875
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6023 46.5323C33.8228 46.8896 35.114 47.0813 36.45 47.0813C43.999 47.0813 50.1187 40.9616 50.1187 33.4125C50.1187 25.8635 43.999 19.7438 36.45 19.7438C28.901 19.7438 22.7812 25.8635 22.7812 33.4125C22.7812 38.724 25.8108 43.3279 30.2362 45.5905",
    stroke: "#A80A01",
    strokeWidth: 2.27812
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.3,
    cy: 18.225,
    r: 1.51875,
    stroke: "#A80A01",
    strokeWidth: 1.51875
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5998,
    cy: 18.225,
    r: 1.51875,
    stroke: "#A80A01",
    strokeWidth: 1.51875
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5998,
    cy: 54.675,
    r: 1.51875,
    stroke: "#A80A01",
    strokeWidth: 1.51875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.722 49.1446C25.3497 48.3169 23.7415 47.8406 22.022 47.8406V56.9531H31.1345C31.1345 55.4071 30.7495 53.951 30.0701 52.6755M26.722 49.1446L34.8605 41.0062L30.0701 52.6755M26.722 49.1446C28.1324 49.9954 29.2936 51.2175 30.0701 52.6755",
    stroke: "#A80A01",
    strokeWidth: 1.51875,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArmazenamento);
export default __webpack_public_path__ + "static/media/Armazenamento.b3eeacd52e27d014ce7f7a4286fc1bde.svg";
export { ForwardRef as ReactComponent };